import { useContext } from 'react';
import { useLocation } from 'react-router-dom';

import { Box } from '@mui/material';

import { DataContext } from 'providers/data';

import NavTitle from 'components/views/NavTitle';
import ContainerSubPage from 'components/views/ContainerSubPage';

const TermsOfUse = () => {
    const { state } = useLocation();
    const { serviceTerms } = useContext(DataContext);

    return (
        <ContainerSubPage title='Alteração de forma de pagamento e/ou vencimento' link='/faturas/alterar-pagamento'>
            <NavTitle title={`TERMO DE ADESÃO AO SERVIÇO DE ${state?.type === '22' ? 'DÉBITO AUTOMÁTICO' : 'BOLETO ELETRÔNICO'}`} />
            {serviceTerms &&
                <Box
                    fontSize='.875rem'
                    lineHeight='1.125rem'
                    paddingTop='1.3125rem'
                    textAlign='justify'
                    dangerouslySetInnerHTML={{ __html: `${serviceTerms}` }}
                    sx={{
                        gap: '.75rem',
                        display: 'flex',
                        flexDirection: 'column',
                        'p:first-child': {
                            display: 'none'
                        }
                    }}
                />
            }
        </ContainerSubPage>
    )
}

export default TermsOfUse;